module.exports = __webpack_public_path__ + "img/register_06.fbf71b20.png";